<template>
  <div class="wt2-modal-inner">
    <div class="-title wt2-text-l2">Settings</div>
    <div class="wt-setting-panel-wrapper">
      <div class="wt-setting-panel wt-panel-content-update">
        <div class="wt-setting-panel-header">Personal Details</div>
        <div class="wt-setting-panel-content wt-settings-panel-content-update">
          <form @submit="saveChanges">
            <div class="row form-group wt-form-group">
              <div class="col-xs-6">
                <label class="control-label">First Name</label>
                <input
                  type="text"
                  class="form-control"
                  name="firstName"
                  v-model="firstName"
                />
              </div>
              <div class="col-xs-6">
                <label class="control-label">Last Name</label>
                <input
                  type="text"
                  class="form-control"
                  name="lastName"
                  v-model="lastName"
                />
              </div>
            </div>
            <div class="row form-group wt-form-group has-feedback">
              <div
                class="col-xs-6 js-studio-name wt-form-group has-feedback wt-hidden"
                :class="{
                  'has-success': studioName,
                  'has-error': !studioName,
                }"
              >
                <label class="control-label">Studio Name</label>
                <input
                  v-if="userType.INDIVIDUAL_CREATOR"
                  type="text"
                  class="form-control js-studio-name"
                  name="studioName"
                  v-model="studioName"
                />
                <div v-else>
                  <span
                    class="help-block js-error-studio-name"
                    :class="{
                      hidden: !studioName,
                    }"
                    >You must enter a studio name.</span
                  >
                  <input
                    type="text"
                    class="form-control"
                    readonly="readonly"
                    name="studioName"
                    v-model="studioName"
                  />
                </div>
                <span
                  class="wticon wticon-v-01 js-error-studio-name-feedback form-control-feedback"
                ></span>
              </div>

              <div class="col-xs-12 wt-form-group has-success has-feedback">
                <label class="control-label disable">Email</label>
                <input
                  type="email"
                  class="form-control"
                  name="title"
                  readonly="readonly"
                  :value="email"
                />
                <span
                  class="wticon wticon-v-01 js-error-email-feedback form-control-feedback"
                ></span>
              </div>
            </div>

            <div class="row row form-group wt-form-group">
              <div class="col-xs-offset-4">
                <button type="submit" class="js-save-changes btn btn-default">
                  Save Changes
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="wt-setting-panel">
        <div class="wt-setting-panel-header">Social Profiles</div>
        <div class="wt-setting-panel-content wt-settings-panel-content-user">
          <div class="wt-settings-panel-user-placeholder">
            <img class="js-user-image" :src="avatarUrl" />
          </div>
          <div v-if="socials.length === 0" class="js-not-connected-with-social">
            <div class="wt-settings-h1">
              Your wochit account is not<br />associated with any social profile
            </div>
            <div class="wt-settings-p"></div>
          </div>
          <div v-else class="js-connected-with-social">
            <div class="wt-settings-p">
              Your wochit account is associated with these profiles:
            </div>
            <ul class="list-inline wt-social-icons js-social-icons">
              <li :key="i" v-for="(social, i) in socials">
                <a href="#"
                  ><img
                    :src="'/resources/img/social/' + social + '.png'"
                    :title="social"
                /></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div v-if="!userSSO" class="wt-setting-panel wt-update-password">
        <div class="wt-setting-panel-header">Password</div>
        <div class="wt-setting-panel-content wt-settings-panel-content-center">
          <button
            v-if="!passwordSend"
            @click="sendResetEmail"
            class="js-change-password btn btn-default"
          >
            Change Password
          </button>
          <div v-else class="js-thanks">
            If your email has a wochit account you'll be receiving instructions
            on how to reset your password in just a moment.
          </div>
        </div>
      </div>
      <div class="wt-setting-panel">
        <div class="wt-setting-panel-header">General Settings</div>
        <div
          class="wt-setting-panel-content wt-settings-panel-content-notification"
        >
          <div class="wt-options-group-label js-setting-panel">
            Text overlays
          </div>
          <div class="wt-options-group js-setting-panel">
            <div class="wt-spell-check">
              <span class="wt-toggle-caption">Use spell checker</span>
              <span class="wt-spell-check-toggle">
                <input
                  type="checkbox"
                  id="spellCheckToggle"
                  name="spellCheckToggle"
                  @change="saveChanges($event)"
                  v-model="enableSpellChecker"
                  class="js-spellcheck"
                />
                <label for="spellCheckToggle"></label>
              </span>
            </div>
          </div>

          <div class="wt2-sg">
            <div class="wt-options-group-label js-notifications">
              Send notifications when...
            </div>
            <div class="wt-options-group -with-dropdown js-notifications">
              <span class="wt-toggle-caption">Video production completed:</span>
              <wt-dropdown
                class="-input"
                :current-item-id="videoPublishNotificationId"
                type="underline"
                :items="videoCompleteOptions"
                :on-click-item="
                  (id, item, event) => {
                    videoPublishNotificationId = id;
                    notification(event);
                  }
                "
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import app from 'app';
import Analytics from 'c/WtAnalytics';
import _ from 'lodash-extended';
import { mapState, mapGetters, mapMutations } from 'vuex';

export default {
  store() {
    return app.rootStore;
  },
  name: 'WtSettings',
  data() {
    return {
      firstName: null,
      lastName: null,
      studioName: null,
      videoPublishNotificationId: 1,
      enableSpellChecker: null,
      notifications: null,
      socials: [],
      passwordSend: false,
      videoCompleteOptions: [
        { label: 'None', id: 0 },
        { label: 'Email', id: 1 },
        { label: 'In-App', id: 2 },
        { label: 'Email and In-App', id: 3 },
      ],
      productionLinesOptions: [
        {
          id: -1,
          label: 'Remember Last',
        },
      ].concat(app.programmers.map((p) => p.pick(['id', 'label']))),
    };
  },
  async created() {
    this.firstName = this.$store.state.user.firstName;
    this.lastName = this.$store.state.user.lastName;
    this.enableSpellChecker = this.$store.state.user.enableSpellChecker;
    if (app.programmers.length > 1) {
      this.studioName = app.culture.settingsPage.MULTIPLE_STUDIOS;
    } else {
      this.studioName = app.programmers.first().get('label');
    }
    let response;
    try {
      response = await app.api.Settings.social();
    } catch (e) {
      console.error(e);
    }
    try {
      this.notifications = await app.api.Settings.getNotifications();
      this.videoPublishNotificationId = this.notificationJsonToBit(
        this.notifications.VIDEO_PUBLISHED
      );
    } catch (e) {
      console.error(e);
    }
    if (!_.isEmpty(response)) {
      this.socials = Object.keys(response);
    }
  },

  computed: Object.assign(
    {},
    mapState({
      email: (state) => state.user.userId,
      avatarUrl: (state) =>
        state.user.avatar || '/resources/img/anonymoususer.png',
    }),
    mapGetters({
      userSSO: 'user/isSSO',
      userType: 'user/type',
    })
  ),

  methods: Object.assign(
    {
      saveChanges(e) {
        if (e && e.preventDefault) {
          e.preventDefault();
        }
        const data = {
          modifications: {
            FIRST_NAME: this.firstName,
            LAST_NAME: this.lastName,
            ENABLE_SPELL_CHECKER: this.enableSpellChecker,
          },
        };
        if (this.userType.INDIVIDUAL_CREATOR) {
          data.modifications.STUDIO_NAME = this.studioName;
        }
        app.api.Settings.saveChanges(data)
          .then(() => {
            this.userUpdate({
              firstName: this.firstName,
              lastName: this.lastName,
              enableSpellChecker: this.enableSpellChecker,
            });
            if (this.userType.INDIVIDUAL_CREATOR) {
              app.programmers.first().set('programmerName', this.studioName);
              app.programmers.first().set('label', this.studioName);
            }
            app.notificationController.push({
              uniqueGroupName: 'SETTING_CHANGE',
              text: app.culture.get(
                'notificationMessages.SUCCESS_SETTINGS_SAVE_CHANGES'
              ),
              type: 'SUCCESS',
              timeout: 2500,
            });
          })
          .fail(() => {
            app.notificationController.push({
              uniqueGroupName: 'SETTING_CHANGE',
              text: app.culture.get('alert.CHANGES_FAILED_TO_SAVE'),
              type: 'ERROR',
              timeout: 2500,
            });
          });
      },
      sendResetEmail() {
        Analytics.trigger('analytics:settings:clickedChangePassword');
        app.api.Settings.sendResetEmail(this.email).then(() => {
          this.passwordSend = true;
        });
      },
      notificationBitToJson(bit) {
        const o = { EMAIL: false, IN_APP: false };
        if (bit & 1) {
          o.EMAIL = true;
        }
        if (bit & 2) {
          o.IN_APP = true;
        }
        return o;
      },
      notificationJsonToBit(o) {
        let bit = 0;
        if (o.EMAIL) {
          bit += 1;
        }
        if (o.IN_APP) {
          bit += 2;
        }
        return bit;
      },
      notification: function (e) {
        if (!this.notifications) {
          return;
        }
        const data = {
          events: {},
        };
        if (this.notifications.VIDEO_PUBLISHED) {
          data.events.VIDEO_PUBLISHED = this.notificationBitToJson(
            this.videoPublishNotificationId
          );
          Analytics.trigger('analytics:settings:setNotification', {
            type: 'video was published',
            email: data.events.VIDEO_PUBLISHED.EMAIL,
            inApp: data.events.VIDEO_PUBLISHED.IN_APP,
          });
        }
        app.api.Settings.setNotifications(data)
          .then((response) => {
            console.log('setNotifications =', response);
            this.notifications = response.events;
            app.notificationController.push({
              uniqueGroupName: 'SETTING_CHANGE',
              text: app.culture.get(
                'notificationMessages.SUCCESS_SETTINGS_SAVE_CHANGES'
              ),
              type: 'SUCCESS',
              timeout: 2500,
            });
          })
          .fail(() => {
            app.notificationController.push({
              uniqueGroupName: 'SETTING_CHANGE',
              text: app.culture.get('alert.CHANGES_FAILED_TO_SAVE'),
              type: 'ERROR',
              timeout: 2500,
            });
          });
      },
    },
    mapMutations({
      userUpdate: 'user/update',
    })
  ),
};
</script>

<style lang="scss" scoped>
@import '_custom_mixins.scss';
.wt-setting-panel-wrapper {
  display: grid;
  grid-template-rows: 1fr 1fr;
  grid-template-columns: 1fr 1fr;
  grid-gap: 10px;
  max-width: 1000px;
  margin: auto;
  .wt-setting-panel {
    font-size: 19px;
    font-weight: 400;
    min-height: 316px;
    -webkit-box-shadow: 3px 3px 5px 0 rgba(211, 212, 213, 0.51);
    -moz-box-shadow: 3px 3px 5px 0 rgba(211, 212, 213, 0.51);
    box-shadow: 3px 3px 5px 0 rgba(211, 212, 213, 0.51);
    .btn {
      border: 0;
      border-radius: 2px;
      font-weight: 400;
      width: 168px;
      height: 36px;
    }

    .btn-default {
      background-color: $wt-purple;
    }

    .btn-default:hover {
      background-color: $wt-purple-dark;
    }
    &.wt-update-password {
      display: flex;
      flex-direction: column;
    }
  }
}

.wt-setting-panel-header {
  height: 55px;
  color: $dark-text-color;
  background-color: #ebedee;
  font-size: 18px;
  font-weight: 400;
  padding: 16px;
}

.wt-setting-panel-content {
  height: calc(100% - 55px);
  padding: 20px;
  font-size: 18px;
  background-color: #ffffff;

  .wt-settings-h1 {
    font-size: 18px;
    font-weight: 400;
  }

  .wt-settings-p {
    font-size: 14px;
  }
}

.wt-settings-panel-content-center {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1 auto;
}

.wt-settings-panel-content-notification {
  padding: 20px;
  text-align: left;

  .wt-checkbox {
    margin-bottom: 10px;

    input:checked + span:after {
      border-color: #0fe2b8;
    }
  }

  .dropdown.wt-dropdown ul.dropdown-menu {
    margin-top: 0;
    max-height: 215px;
    overflow-y: overlay;
  }

  .btn.btn-link {
    color: #565a5c;
    font-weight: 400;
  }
  .wt-default-production-line {
    display: flex;
    align-items: center;
  }

  .wt-options-group-label {
    color: #565a5c;
    font-weight: 500;
    margin-bottom: 5px;
  }

  .wt-checkbox:last-child {
    margin-bottom: 0;
  }

  .wt-spell-check,
  .wt-notify-timeline,
  .wt-notify-produced {
    display: flex;
    align-items: center;
  }

  .wt-notify-timeline {
    margin-bottom: 10px;
  }

  .wt-spell-check-toggle,
  .wt-notify-timeline-toggle,
  .wt-notify-produced-toggle {
    @include checkBoxSlide(
      26px,
      12px,
      $iconBGChecked: #fff,
      $trackBGChecked: #16e2b8
    );
    label {
      &:after {
        box-shadow: 1px 1px 4px 0 rgba(0, 0, 0, 0.37);
      }
    }
  }

  .wt-options-group {
    position: relative;
    width: 100%;
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }

  .wt-toggle-caption {
    font-weight: 400;
    font-size: 14px;
    padding-right: 10px;
    flex: 1;
  }

  .wt-options-group-label {
    -webkit-font-smoothing: auto;
  }

  .wt-options-group.-with-dropdown {
    display: flex;
    align-items: center;
    margin-bottom: 0;
    height: 40px;
    &.-first {
      margin-bottom: 10px;
    }
  }

  .wt2-dropdown.underline .wt2-dropdown-button {
    height: 40px;
  }

  .dropdown {
    .wt2-dropdown {
      width: 170px;
    }
    &.-video-published ul {
      top: unset;
      bottom: 40px;
    }

    &.-production-line {
      .dropdown-menu {
        max-height: 200px;
      }
      .right {
        ul {
          right: 0;
          &:before {
            display: none;
          }
        }
        li {
          height: 40px;
        }
      }
      button {
        > span {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
  .-input {
    width: 170px;
  }
}

.wt-settings-panel-content-user {
  text-align: center;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  .wt-social-icons {
    li {
      padding: 10px;
      img {
        width: 27px;
      }
    }
  }
}

.wt-settings-panel-content-update {
  .btn {
    margin-top: 19px;
  }
}

.wt-settings-panel-footer-button {
  font-size: 11px;
  cursor: pointer;
  float: left;
  border-right: solid 1px #e6e6e6;
  padding: 16px;
  line-height: 11px;
  text-align: center;
  color: #595959;
}

.wt-settings-panel-user-placeholder {
  width: 99px;
  height: 99px;
  border-radius: 50%;
  background-color: transparent;
  margin-bottom: 24px;
  img {
    width: 96px;
    height: 96px;
    border-radius: 150px;
    -webkit-border-radius: 150px;
  }
}

.wt-options-group-label {
  font-size: 14px;
  font-weight: 400;
}

.wt-form-group {
  &.row.form-group {
    margin-bottom: 17px;
  }
  &.row.form-group:first-child {
    margin-top: 0px;
  }
  &.row.form-group:last-child {
    margin-top: 0px;
    margin-bottom: 0px;
  }

  label {
    font-weight: 400;
    font-size: 14px;
    margin-bottom: 3px;
  }

  .form-control {
    border-radius: 0;
    border: 1px solid $dark-text-color;
    height: 31px;
  }

  .form-control-feedback {
    right: 15px;
  }

  .help-block {
    font-size: 13px;
    margin: 5px 0px;
    font-weight: 400;
  }

  .form-control:focus {
    border-color: $dark-text-color;
    box-shadow: none;
  }

  .has-error {
    .control-label {
      color: $dark-text-color;
    }
    .help-block {
      color: $wt-violet-dark;
    }
    .form-control-feedback {
      color: $wt-violet-dark;
    }
    .form-control:focus {
      border-color: $dark-text-color;
      box-shadow: none;
    }
  }

  .has-success {
    .control-label {
      color: $dark-text-color;
    }
    .help-block {
      color: $wt-teal-light;
    }
    .form-control-feedback {
      color: $wt-teal-light;
      line-height: 34px;
    }
    .form-control:focus {
      border-color: #565a5c;
      box-shadow: none;
    }
  }
}
</style>
